import { EditMacroProtocolAction, EditMetricMacroProtocolState } from "shared-ui/reducers/EditMacroProtocol";
import { Dispatch } from "react";
import { GoalTypeFragment } from "../../../types";
import { MacroProtocolForm } from "./MacroProtocolForm";

interface MetricMacroProtocolFormProps {
  state: EditMetricMacroProtocolState;
  dispatch: Dispatch<EditMacroProtocolAction>;
  goalTypes: readonly GoalTypeFragment[];
}

export const MetricMacroProtocolForm = ({ state, dispatch, goalTypes }: MetricMacroProtocolFormProps) => {
  return <MacroProtocolForm
    state={state}
    dispatch={dispatch}
    goalTypes={goalTypes} />;
};
